export default __webpack_public_path__ + "static/media/watchNotConnected.cdbd8a08.svg";